// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Hp-z","selected":"Ip-z"};